<template>
  <div v-if="tools.length > 0">
    <div id="addToolProxyContainer" class="add-tool-proxy-container"></div>
    <div class="apps-head">
      <span class="label">Apps</span>
      <button class="add-app-btn" id="createToolProxy">add app</button>
    </div>
    <div class="added-apps pl-0 pr-0">
        <template v-for="(proxy, index) in proxies">
            <div class="content-row pl-0 pr-0">
                <template v-if="proxy.launchMode === 'NewTab'">
                  <a :href="generateLtiLink(proxy)" target="_blank" class="title" :title="proxy.name">{{proxy.name}}</a>
                </template>
                <template v-else>
                  <span class="title" :title="proxy.name">{{proxy.name}}</span>
                </template>
                <div class="btn-container pr-0">
	                <b-btn class="ic_btn ic_pencil mr-2" style="cursor: pointer;" @click="onEdit(proxy)"></b-btn>
	                <b-btn class="ic_btn ic_bin" style="cursor: pointer;" @click=onDelete(proxy)></b-btn>
	             </div>
            </div>
        </template>
    </div>

    <b-popover ref="addToolProxyPopover" container="addToolProxyContainer" target="createToolProxy" triggers="click" @show="onShow" @shown="onShown">

        <template slot="title">
          <span class="title">Add App Proxy</span>
          <button class="btn_close" aria-label="close" @click="onClose">
            <span class="ic-close"></span>
          </button>
        </template>

        <div class="row fld_row">
          <div class="col-4 fld_val">
            <label>App Name <sup>*</sup></label>
          </div>
          <div class="col-8 fld_input">
            <b-form-group label-for="appName" :state="nameState" class="fld_val_inner"
                placeholder="type in tool proxy name" invalid-feedback="This field is required">
                <b-form-input ref="appName" id="appName"
                    v-model="name" :state="nameState">
                </b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-4 fld_val">
            <label>App <sup>*</sup></label>
          </div>
          <div class="col-8 fld_input">
            <b-form-group label-for="app"
                :state="appState" class="fld_val_inner" invalid-feedback="This field is required">
                <b-form-select id="app" v-model="app"
                    :state="appState" :options="tools">
                  </b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-4 fld_val">
            <label>Launch Mode <sup>*</sup></label>
          </div>
          <div class="col-8 fld_input">
            <b-form-group label-for="launchMode" class="fld_val_inner">
                <b-form-select id="launchMode" v-model="launchMode"
                    :options="[{value: 'NewTab', text: 'NewTab'}, {value: 'Inline', text: 'Inline'}]" size="sm">
                  </b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="row btn_container pb-4">
          <div class="col-12">
            <button class="" @click="onOk">save</button>
          </div>
        </div>

    </b-popover>

  </div>
</template>

<script>
    import _ from 'lodash'
    import { mapActions } from 'vuex'

    export default {
      name: 'add-app-proxy',
      props: ['parent', 'contextId'],
      data () {
        return {
          uuid: '',
          name: '',
          nameState: null,
          app: '',
          appState: null,
          resourceLinkId: '',
          launchMode: 'Inline',
          tools: [],
          proxies: [],
          proxy: ''
        }
      },

      mounted () {
        this.loadToolsForInstitution()
      },

      watch: {
        name (val) {
          if (val) {
            this.nameState = true
          }
        },

        app (val) {
          if (val) {
            this.appState = true
          }
        }
      },

      methods: {
        ...mapActions([
          'loadAllToolsForInstitution',
          'loadToolProxies',
          'createToolProxy',
          'loadDeleteToolProxy'
        ]),

        loadToolsForInstitution () {
          this.tools = []
          this.loadAllToolsForInstitution().then(res => {
            let tools = _.orderBy(res.content, ['lastUpdatedTime'], ['desc'])
            if (tools.length > 0) {
              $.each(tools, (i, tool) => {
                if (i === 0) {
                  this.tools.push({text: 'Select App', value: ''})
                }
                this.tools.push({text: tool.toolName, value: tool.toolName})
              })
            }
          })
          this.loadProxies()
        },

        loadProxies () {
          this.proxies = []
          this.loadToolProxies(this.contextId).then(res => {
            this.proxies = _.orderBy(res.content, ['lastUpdatedTime'], ['desc'])
          })
        },

        generateLtiLink (proxy) {
          let origin = window.location.origin
          let token = localStorage.getItem('token')
//          let ltiLaunchUrl = origin + '/toolProxy/launch/' + proxy.uuid + '/' + proxy.uuid + '?token=' + token
            let ltiLaunchUrl = origin + '/lticonsumer/tool/' + proxy.uuid + '/launch?token=' + token
          return ltiLaunchUrl
        },

        addApp () {
          this.proxy = ''
          this.$refs.addToolProxyPopover.$emit('open')
        },

        onClose () {
          this.proxy = ''
          this.parent.$refs.menuDropDown.hide(true)
          this.$refs.addToolProxyPopover.$emit('close')
        },

        onEdit (proxy) {
          this.proxy = proxy
          this.$refs.addToolProxyPopover.$emit('open')
        },

        onDelete (proxy) {
          this.loadDeleteToolProxy(proxy.uuid).then(res => {
            if (res.status === 204) {
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: 'App proxy "' + proxy.name + '" deleted successfully.'
              })
              this.loadProxies()
            }
          })
        },

        onOk () {
          if (!this.name) {
            this.nameState = false
          }
          if (!this.app) {
            this.appState = false
          }
          if (this.name && this.app) {
            let data = {
              name: this.name,
              tool: {'toolName': this.app},
              contextId: this.contextId,
              launchMode: this.launchMode
            }
            let status = 'success'
            let text = 'App proxy "' + this.name + '" added successfully.'
            if (this.uuid) {
              data.uuid = this.uuid
              data.resourceLinkId = this.resourceLinkId
              text = 'App proxy "' + this.name + '" updated successfully.'
            } else {
              data.resourceLinkId = this.generateResourceLinkId()
            }
            this.createToolProxy(data).then(res => {
              this.proxy = ''
              this.$refs.addToolProxyPopover.$emit('close')
              if (res) {
                if (res.status === 409) {
                  text = 'App proxy with name "' + this.name + '" already exists.'
                  status = 'warn'
                }
                this.$notify({
                  group: 'notify',
                  type: status,
                  title: '',
                  text: text
                })
                this.loadProxies()
              }
            })
          }
        },

        generateResourceLinkId () {
          var d = new Date().getTime()
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },

        onShow () {
          this.app = ''
          this.uuid = ''
          this.name = ''
          this.resourceLinkId = ''
          this.launchMode = 'Inline'
          this.appState = null
          this.nameState = null
        },

        onShown () {
          if (this.proxy) {
            this.uuid = this.proxy.uuid
            this.name = this.proxy.name
            this.app = this.proxy.tool.toolName
            this.launchMode = this.proxy.launchMode
            this.resourceLinkId = this.proxy.resourceLinkId
          }
          this.focusRef(this.$refs.appName)
        },

        focusRef (ref) {
          this.$nextTick(() => {
            this.$nextTick(() => {
              (ref.$el || ref).focus()
            })
          })
        }
      }
    }
</script>

<style>
  .page-heading .btn-container .create-section-menu .dropdown-menu a,
  .content-row a.title {
    padding: 4px 12px;
  }
  .page-heading .btn-container .create-section-menu .added-apps .content-row {
    padding: 3px 0;
  }
  .page-heading .btn-container .create-section-menu .added-apps .content-row .title {
    width: calc(100% - 60px);
    max-width: calc(100% - 60px);
  }
  .page-heading .btn-container .create-section-menu .added-apps .content-row .btn-container {
    margin-top: 6px;
  }
  .page-heading .btn-container .create-section-menu .dropdown-menu {
    width: 280px;
    max-width: 280px;
    left: -75px !important;
    box-shadow: 2px 4px 8px 1px rgba(0, 0, 0, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/app/course/components/AddAppProxy.vue